module.exports = "/images/lines-10.jpg";